import React from "react";
import { useNavigate } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
export default function AdvantageSection({ data }) {
  const navigate = useNavigate();
  return (
    <div className="py-5">
      <div className="custom-container">
        <div className="row align-items-center">
          {/* LEFT */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            {/* <h3 className="text-success FS40FW600 mb-0">{data.titleTop}<br />
              <span className="main-title text-black">
                {data.titleMain}
              </span>
            </h3> */}
            {data.titleSection() && <div>{data.titleSection()}</div>}

            <div className="info-box academy-highlight-box FS15FW400 fw-700">{data.highlightBox}</div>

            <p className="subtitle FS18FW400 fw-500">{data.description}</p>

            <button className="plus-sans FS17FW500 primary-btn fw-700" onClick={() => {
              if (data.buttonLink) {
                if (data.buttonLink.startsWith('http://') || data.buttonLink.startsWith('https://')) {
                  window.location.href = data.buttonLink;
                } else {
                  navigate(data.buttonLink);
                }
              } else {
                const modalEl = document.getElementById('staticBackdrop');
                if (modalEl && window.bootstrap?.Modal) {
                  const modal = new window.bootstrap.Modal(modalEl);
                  modal.show();
                }
              }
            }}>{data.buttonText} <img src="/images/web-new-images/new-dark-arrow.svg" alt="Register Now" /></button>
          </div>

          {/* RIGHT TIMELINE */}
          <div className="col-lg-6">
            <div className="timeline">
              {data.timeline.map((item, i) => (
                <div className="timeline-item" key={i}>
                  <div className="timeline-left">
                    <div className={`circle circle-${i}`}>{item.number}</div>
                    {i !== data.timeline.length - 1 && (
                      <div className="line"></div>
                    )}
                  </div>

                  <div className="timeline-content plus-sans">
                    <h5 className="FS24FW500 fw-700">{item.title}</h5>
                    <p className="FS16FW500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
